import produce from "immer";
import {
  SET_INITIAL_USER_INFO,
  SET_MANAGER_EMAIL,
  SET_MANAGER_EMAIL_REQUIRED,
  SET_PUBLIC_KEY,
  SET_RENEWAL_INTERCEPT_REQUIRED,
  SET_USER_AUTHENTICATED,
  SET_USER_AUTHENTICATION_FAIL_REASON,
  GET_PRODUCT_ID,
  SET_NEWSFEED_COUNTRY_BLOCK,
  GET_BADGE_URL,
  GET_IS_TMS_REQUIRED,
  SET_SELECTED_COUNTRY,
  SET_SELECTED_LANGUAGE,
} from "../constants";
const reducerInitialState = {
  isUserAuthenticated: false,
  lgId: 0,
  luuId: 0,
  leuId: 0,
  customuuid: 0,
  pub: "",
  selectedLanguage: "EN",
  managerEmail: "",
  isLoading: false,
  isManagerEmailRequired: false,
  isNewsfeedTzBlocked: false,
  userAuthenticationFailReason: "",
  productID: "",
  getBadgeURL: "",
  isTMSCallRequired: true,
  selectedCountry: "",
};

const common = (state = reducerInitialState, action: any) => {
  switch (action.type) {
    case SET_INITIAL_USER_INFO:
      return produce(state, (draftState: any) => {
        draftState.lgId = action?.payload?.lgId || 0;
        draftState.luuId = action?.payload?.luuId || 0;
        draftState.leuId = action?.payload?.leuId || 0;
        draftState.customuuid = action?.payload?.customuuid || 0;
        draftState.isLoading = false;
      });
    case SET_PUBLIC_KEY:
      return produce(state, (draftState: any) => {
        draftState.pub = action?.payload?.pub || "";
        draftState.isLoading = false;
      });
    case SET_SELECTED_LANGUAGE:
      return produce(state, (draftState: any) => {
        draftState.selectedLanguage = action?.payload?.language || "EN";
        draftState.isLoading = false;
      });
    case SET_NEWSFEED_COUNTRY_BLOCK:
      return produce(state, (draftState: any) => {
        draftState.isNewsfeedTzBlocked = action?.payload?.isBlocked || "";
        draftState.isLoading = false;
      });
    case SET_MANAGER_EMAIL:
      return produce(state, (draftState: any) => {
        draftState.managerEmail = action?.payload?.managerEmail || "";
        draftState.isLoading = false;
      });
    case SET_MANAGER_EMAIL_REQUIRED:
      return produce(state, (draftState: any) => {
        draftState.isManagerEmailRequired = action?.payload?.isManagerEmailRequired || false;
        draftState.isLoading = false;
      });
    case SET_USER_AUTHENTICATED:
      return produce(state, (draftState: any) => {
        draftState.isUserAuthenticated = action?.payload?.isUserAuthenticated || false;
        draftState.userAuthenticationFailReason = "";
        draftState.isLoading = false;
      });
    case SET_USER_AUTHENTICATION_FAIL_REASON:
      return produce(state, (draftState: any) => {
        draftState.isUserAuthenticated = false;
        draftState.userAuthenticationFailReason = action?.payload?.userAuthenticationFailReason || "";
        draftState.isLoading = false;
      });
    case SET_RENEWAL_INTERCEPT_REQUIRED:
      return produce(state, (draftState: any) => {
        draftState.isRenewalInterceptRequired = action?.payload?.isRenewalInterceptRequired || false;
        draftState.isLoading = false;
      });
    case GET_PRODUCT_ID:
      return produce(state, (draftState: any) => {
        draftState.productID = action?.payload?.productID || "";
        draftState.isLoading = false;
      });
    case GET_BADGE_URL:
      return produce(state, (draftState: any) => {
        draftState.getBadgeURL = action?.payload?.getBadgeURL || "";
        draftState.isLoading = false;
      });
    case GET_IS_TMS_REQUIRED:
      return produce(state, (draftState: any) => {
        draftState.isTMSCallRequired = action?.payload?.isTMSCallRequired || "";
        draftState.isLoading = false;
      });
    case SET_SELECTED_COUNTRY:
      return produce(state, (draftState: any) => {
        draftState.selectedCountry = action?.payload?.selectedCountry || "";
        draftState.isLoading = false;
      });
    default:
      return state;
  }
};

export default common;
